import React, { Fragment } from 'react';
import styled from "styled-components";

const Wrapper = styled.div`
    margin-left: ${props => props.marginLeft || 'auto'};
    margin-right: ${props => props.marginRight || 'auto'};
    margin-top: ${props => props.marginTop || 0};
    margin-bottom: ${props => props.marginBottomWrapper || '40px'};
    color: ${props => props.color};

    ${props => props.theme.mediaQueries.medium}{
        width: 335px;
        margin-left: 0;
        margin-right: 0;
        font-size: 0.9px;
    }
`;

const H1 = styled.h1`
    font-size: ${props => props.fontSizeH1 || '1.83rem'};
    font-weight: ${props => props.fontWeightH1};
    line-height: ${props => props.lineHeightH1 || '24px'};
    margin-bottom: ${props => props.marginBottomH1 || '4px'};

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.7rem;
        margin-bottom: 8px;
    }
`

const P = styled.p`
    font-size: ${props => props.fontSizeP || '1.33rem'};
    line-height: ${props => props.lineHeightP || '24px'};
    margin-bottom: ${props => props.marinBottomP};

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.7rem;
    }
`

const NumbersList = ({
    headerText, 
    paragraphText,
    content,
    ...props
}) => {
    const renderContent = (content) => {
        return content.map((item, index) => {
            return(
                <Fragment key={index}>
                    <H1 
                        fontSizeH1={item.fontSizeH1}
                        fontWeightH1={item.fontWeightH1}
                        lineHeightH1={item.lineHeightH1}
                        marginBottomH1={item.marginBottomH1}
                    >{index + 1 + '. ' + item.headerText}</H1>
                    <P
                       fontSizeP={item.fontSizeP}
                       lineHeightP={item.lineHeightP}
                       marinBottomP={item.marinBottomP}
                    >{item.paragraphText}</P>
                </Fragment>
            )
        })
    }

    return (
        <Wrapper {...props}>
            {renderContent(content)}
        </Wrapper>
    )
}

export default NumbersList;